import { render, staticRenderFns } from "./Decor.vue?vue&type=template&id=7b180aa7&scoped=true&"
import script from "./Decor.vue?vue&type=script&lang=js&"
export * from "./Decor.vue?vue&type=script&lang=js&"
import style0 from "./Decor.vue?vue&type=style&index=0&id=7b180aa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b180aa7",
  null
  
)

export default component.exports